"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetCleanupExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const FacadeEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/FacadeEvents");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const configs_1 = require("../../configs/configs");
/**
 * Widget extension that removes assets after widget destroyed.
 */
class AssetCleanupExtension extends WidgetExtensionPlugin_1.default {
    /**
     * Creates asset cleanup extension.
     *
     * @param definition
     * @param assetManager
     */
    constructor(definition, assetManager) {
        super(definition);
        this.assetManager = assetManager;
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition, container.get("asset_manager"));
    }
    /**
     * @inheritDoc
     */
    initialize(widget) {
        this.widget = widget;
        return new Promise((resolve) => {
            widget.getEventContainer()
                .on(FacadeEvents_1.FacadeEvents.DESTROY, () => this.cleanup(widget));
            resolve();
        });
    }
    /**
     * Removes assets.
     *
     * @param widget
     */
    cleanup(widget) {
        const templateTypes = configs_1.configs.loadTemplates;
        const templates = this.widget.getConfig().getTemplates();
        let cssPromises = [];
        for (let i = 0; i < templateTypes.length; i++) {
            if (!templates[templateTypes[i]]) {
                continue;
            }
            templates[templateTypes[i]].getCss().forEach((css) => {
                cssPromises.push(this.assetManager.removeStyle(css));
            });
        }
        Promise.all(cssPromises).catch((error) => {
            this.widget.getEventContainer().emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
        });
    }
}
exports.default = AssetCleanupExtension;
Mixin_1.default(AssetCleanupExtension, IContainerInjection_1.default);
exports.AssetCleanupExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "asset_cleanup",
    class: AssetCleanupExtension
});
